import { MapPin } from "lucide-react";
interface AddressItemProps {
  address: string;
}

const AddressItem = ({ address }: AddressItemProps) => {
  return (
    <div className="flex items-start gap-3 md:justify-start justify-center">
      <MapPin
        style={{ width: "25px", height: "40px" }}
        className="text-black shrink-0"
      />

      <a
        href={`https://maps.google.com/?q=${encodeURIComponent(address)}`}
        target="_blank"
        rel="noopener noreferrer"
        className="text-base text-gray break-words hover:text-black transition-colors font-semibold"
      >
        {address}
      </a>
    </div>
  );
};

export default AddressItem;